import { ElMessage } from 'element-plus'
const interceptors = async (response: Response, config: Config = {}) => {
  const data: JsonFormat = await response.json()
  if (data.status === 404) {
    return Promise.reject(data)
  }

  if (data.code) {
    // TOKEN失效
    if (data.code === 10006) {
      // 清空token,刷新页面
      if (localStorage.getItem('token')) {
        localStorage.clear()
        location.reload()
        return Promise.reject(data)
      }
    }
    if (!config.skipMsg)
      ElMessage.error({
        offset: 120,
        message: data.msg,
        duration: 3000
      })
    return Promise.reject(data)
  } else {
    return Promise.resolve(data)
  }
}

let timer = 0
const errorInterceptor = (err: any) => {
  if (err.toString().indexOf('TypeError') !== -1) {
    clearTimeout(timer)
    timer = setTimeout(() => {
      ElMessage.error({
        message: '网络请求失败',
        duration: 3000
      })
    }, 1000)
    return Promise.reject('网络请求失败')
  } else {
    return Promise.reject(err)
  }
}

interface Config {
  headers?: HeadersInit
  signal?: AbortSignal
  skipMsg?: boolean
}

export interface JsonFormat<T = any> {
  /**0-成功  */
  code: number
  data: T
  /**服务端提示信息 */
  msg: string
  status?: 404
}

const headers: any = { clientType: 'pcweb', Serviceversion: '33' }

const request = {
  get: <T = any>(
    url: string,
    params?: { [key: string]: number | string | boolean | null | undefined },
    config: Config = {}
  ): Promise<JsonFormat<T>> => {
    if (localStorage.getItem('token')) {
      headers.token = localStorage.getItem('token')
    }
    return fetch(request.assemble(url, params), {
      headers: { ...headers, ...config.headers }
    })
      .then((res) => interceptors(res, config))
      .catch((err) => errorInterceptor(err))
  },
  post: <T = any>(url: string, data?: object, config: Config = {}): Promise<JsonFormat<T>> => {
    if (localStorage.getItem('token')) {
      headers.token = localStorage.getItem('token')
    }
    return fetch(url, {
      method: 'POST',
      headers: {
        ...headers,
        'Content-Type': 'application/json',
        ...config.headers
      },
      body: JSON.stringify(data)
    })
      .then((res) => interceptors(res, config))
      .catch((err) => errorInterceptor(err))
  },
  upload: <T = any>(url: string, data?: any, config: Config = {}): Promise<JsonFormat<T>> => {
    if (localStorage.getItem('token')) {
      headers.token = localStorage.getItem('token')
    }
    return fetch(url, {
      signal: config.signal,
      method: 'POST',
      headers: {
        ...headers,
        ...config.headers
      },
      body: data
    })
      .then((res) => interceptors(res, config))
      .catch((err) => errorInterceptor(err))
  },
  assemble: assemble
}

/**
 * 将地址拼接到上
 * @param url 接口地址
 * @param params 参数
 * @returns
 */
function assemble(
  url: string,
  params?: { [key: string]: number | string | boolean | null | undefined }
) {
  if (params) {
    const list = []
    for (let key in params) {
      if (params[key] || params[key] === 0) {
        list.push(`${key}=${params[key]}`)
      }
    }
    if (list.length) url += (url.includes('?') ? '&' : '?') + list.join('&')
  }
  return url
}

export default request
